import { render, staticRenderFns } from "./VerifyInvitation.vue?vue&type=template&id=0fd70994"
import script from "./VerifyInvitation.vue?vue&type=script&lang=js"
export * from "./VerifyInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports